import React from "react";

export const pelangganTable = (handleEdit, handleDelete) => {
  return [
    {
      title: "Id Pelanggan",
      render: (rowData) => {
        return <span>{rowData.id_pelanggan}</span>;
      },
    },
    {
      title: "Jenis Pelanggan",
      render: (rowData) => {
        return <span>{rowData.jenis_pelanggan}</span>;
      },
    },
    {
      title: "Nama Pelanggan",
      render: (rowData) => {
        return <span>{rowData.nama_pelanggan}</span>;
      },
    },
    {
      title: "Nomor HP",
      render: (rowData) => {
        return <span>{rowData.no_hp_pelanggan}</span>;
      },
    },
    {
      title: "Created At",
      render: (rowData) => {
        return <span>{rowData.created_at}</span>;
      },
    },
    {
      title: "Updated At",
      render: (rowData) => {
        return <span>{rowData.updated_at}</span>;
      },
    },
    {
      title: "Action",
      render: (rowData) => {
        return (
          <>
            <button
              className="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded mr-2"
              onClick={(e) => handleEdit(rowData)}
            >
              Edit
            </button>
            <button
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
              onClick={(e) => handleDelete(rowData)}
            >
              Delete
            </button>
          </>
        );
      },
    },
  ];
};
